import { useState } from "react";
import { RatingSummary } from "@interfaces/dto/review.dto";
import { progressBarReview } from "@utils/starRate";

interface Props {
  goFirstPage: () => void;
  totalReviews: number;
  reviewSummary: RatingSummary[];
  setFilteredReviewsRate: (rating: string) => void;
  setFilteredReviewsImg: (rating: string) => void;
  totalImageCount: number;
}

const ReviewFilter = ({
  totalReviews,
  setFilteredReviewsRate,
  setFilteredReviewsImg,
  goFirstPage,
  reviewSummary,
  totalImageCount,
}: Props) => {

  const [activeButton, setActiveButton] = useState<string>("all"); 

  const {
    ratefive,
    ratefour,
    ratethree,
    ratetwo,
    rateone,
  } = progressBarReview({ reviewSummary });

  const handleButtonClick = async (rating: string, img: string) => {
    setActiveButton(rating);
    if (rating === "img") {
      await setFilteredReviewsImg(img);
      await setFilteredReviewsRate("");
    } else {
      await setFilteredReviewsImg("");
      await setFilteredReviewsRate(rating === "all" ? "" : rating);
    }
    goFirstPage();
  };
  
  const renderButton = (buttonName: string, label: string, count: number) => (
    <button
      className={`badge ${activeButton === buttonName ? "active" : ""} ${
        count === 0 ? "disable" : "text-secondary"
      }`}
      onClick={() => handleButtonClick(buttonName, "img")} 
      disabled={count === 0}
    >
      {label} ({count})
    </button>
  );
  
  return (
    <>
      <div className="col-12 col-lg-4 my-2 review-all">
        <div className="d-flex flex-wrap">
          {renderButton("all", "ทั้งหมด", totalReviews)}
          {renderButton("img", "มีรูปภาพ", totalImageCount)}
          {renderButton("5", "5 ดาว", ratefive)}
          {renderButton("4", "4 ดาว", ratefour)}
          {renderButton("3", "3 ดาว", ratethree)}
          {renderButton("2", "2 ดาว", ratetwo)}
          {renderButton("1", "1 ดาว", rateone)}
        </div>
      </div>
    </>
  );
};

export default ReviewFilter;
